;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('BugtrackerCredentialsService', BugtrackerCredentialsService)

  function BugtrackerCredentialsService(
    $http,
    $uibModal,
    $location,
    UserService,
    ServiceUtils
  ) {
    'ngInject'

    return {
      getLatestUsedCredentials: getLatestUsedCredentials,
      getCredentialsList: getCredentialsList,
      updateCredentials: updateCredentials,
      renameCredentialSet: renameCredentialSet,
      removeCredential: removeCredential,

      openCredentialsActionsModal: openCredentialsActionsModal,
      openCredentialsEditConfirmModal: openCredentialsEditConfirmModal,
      openCredentialsRenameModal: openCredentialsRenameModal,
      openDeleteCredentialModal: openDeleteCredentialModal
    }

    function getLatestUsedCredentials(bugtracker) {
      return $http.get(
        UserService.buildAPIUrl(
          '/bugtrackers/' + bugtracker + '/credentials/latest'
        )
      )
    }

    function getCredentialsList(bugtracker) {
      return $http.get(
        UserService.buildAPIUrl('/bugtrackers/' + bugtracker + '/credentials')
      )
    }

    function updateCredentials(bugtracker, model, credentialsId) {
      var form = {
        name: model.name,
        username: model.username,
        password: model.password,
        host: model.host
      }

      return $http
        .put(
          UserService.buildAPIUrl(
            '/bugtrackers/' + bugtracker + '/credentials/' + credentialsId
          ),
          form
        )
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function removeCredential(bugtracker, credentialId) {
      return $http.delete(
        UserService.buildAPIUrl(
          `/bugtrackers/${bugtracker}/credentials/${credentialId}`
        )
      )
    }

    function renameCredentialSet(bugtracker, form, credentialsId) {
      return $http.put(
        UserService.buildAPIUrl(
          '/bugtrackers/' +
            bugtracker +
            '/credentials/' +
            credentialsId +
            '/name'
        ),
        form
      )
    }

    function openCredentialsActionsModal(forceNewSetCreation) {
      return $uibModal.open({
        templateUrl:
          'views/settings/integrations/cs-integration-credentials-actions.html',
        controller: 'csIntegrationCredentialsActionsCtrl',
        size: 'md',
        resolve: {
          forceNewSetCreation: function () {
            return forceNewSetCreation
          }
        }
      }).result
    }

    function openCredentialsEditConfirmModal() {
      return $uibModal.open({
        templateUrl:
          'views/settings/integrations/cs-integration-credentials-edit-confirm.html',
        controller: 'csIntegrationCredentialsEditCtrl',
        size: 'sm'
      }).result
    }

    function openCredentialsRenameModal(name) {
      return $uibModal.open({
        templateUrl:
          'views/settings/integrations/cs-integration-credentials-rename.html',
        controller: 'csIntegrationCredentialsRenameCtrl',
        size: 'sm',
        resolve: {
          name: function () {
            return name
          }
        }
      }).result
    }

    function openDeleteCredentialModal(name) {
      return $uibModal.open({
        templateUrl:
          'views/settings/integrations/cs-integration-credentials-remove-confirm.html',
        controller: 'csIntegrationCredentialsRemoveCtrl',
        size: 'sm',
        resolve: {
          name: function () {
            return name
          }
        }
      }).result
    }
  }
})()
